<template>
    <iframe class="w-full h-48 lg:h-96 mt-6"
            :src="'https://www.youtube.com/embed/' + this.$props.code"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
    </iframe>
</template>

<script>
    export default {
        props: {
            code: String
        }
    }
</script>
